import React, {Fragment, useEffect, useState} from 'react';
import axios from "axios";

const URL = String(process.env.GATSBY_WPGRAPHQL_URL);

const JobCard = ({career}) => {
  const {title, jobPostings, uri} = career

  return (
    <div className="card">
      {title && (
        <h5 className="card-title">{title}</h5>
      )}
      <div className="card-body">
        {title && (
          <li>
            <p>JOB TITLE & LOCATION: </p>
            <p>{title}{jobPostings.location ? `, ${jobPostings.location}` : ''}</p>
          </li>
        )}
        {jobPostings.class && (
          <li>
            <p>POSITION TYPE:</p>
            <p>{jobPostings.class}</p>
          </li>
        )}
        {jobPostings.status && (
          <li>
            <p>Position Status:</p>
            <p>{jobPostings.status}</p>
          </li>
        )}
        {jobPostings.department && (
          <li>
            <p>DEPARTMENT:</p>
            <p>{jobPostings.department}</p>
          </li>
        )}
      </div>
      <div className="card-btn-container">
        {uri && (
          <a className="btn button-outline-blue" href={uri}>Job Description</a>
        )}
        {jobPostings.jobid && (
          <a className="btn button-solid" target="_blank" href={jobPostings.jobid}>Apply Now</a>
        )}
      </div>
    </div>
  )
}

const JobGrid = ({staticJobs}) => {

  const openJobs = [];
  const acceptingJobs = [];
  const [jobs, setJobs] = useState(staticJobs);

  useEffect(() => {
    axios({
      url: URL,
      method: 'post',
      data: {
        query: `
          query Jobs {
            jobOpportunities {
              nodes {
                title
                content
                slug
                uri
                status
                jobPostings {
                  class
                  department
                  fieldGroupName
                  jobid
                  location
                  referenceNumber
                  status
                }
              }
            }
          }
        `
      }
    }).then((result) => {
      console.log(result);
      setJobs(result.data.data.jobOpportunities.nodes);
    }).catch(error => console.error(error));
  }, []);

  if (jobs) {
    jobs.forEach(job => {
      if (job.status === "publish" && job.jobPostings) {
        if (['Full-Time', 'Part-Time', 'Full-Time or Part-Time', 'On-Call'].includes(job.jobPostings?.class)) {
          openJobs.push(job);
        } else if (job.jobPostings?.status === 'PQ Future Opening') {
          acceptingJobs.push(job);
        }
      }
    });
  }

  return (
    <Fragment>
      <div className="page-intro">
        <h3>Employment Opportunities at Pacific Quest</h3>
        <p>Aloha, and thank you for your interest in Pacific Quest.</p>
           <p>We offer comprehensive medical and supplemental benefit package, growth opportunities, and much more. If you
          are a talented, team-oriented, and dedicated professional who shares our passion for cultivating sustainable
          life skills in the adolescents and young adults we serve, then Pacific Quest may be the place for you!</p>
         <p>For employment consideration, please review our job postings below.</p>
      </div>
      <section className="job-grid">
        {openJobs ? openJobs.map((career, i) => <JobCard key={i} career={career}/>) : null}
      </section>
      
            <div className="page-intro">
       <h3>Future Openings at Pacific Quest</h3>
<p>We are hiring soon for these positions. Please apply ASAP!</p>
      </div>
            <section className="job-grid">
        {acceptingJobs ? acceptingJobs.map((career, i) => <JobCard key={i} career={career}/>) : null}
           </section>    

    </Fragment>
  )
}

export default JobGrid